import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
const _ = require('lodash');

import { MasterConstants } from '../../../../../app/common/constants/master-constants';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from '../../../../services/common/common.service';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { CppUserListService } from '../../../../services/cpp/cpp-user-list.service';
import { dashboradDDL } from '../../../../models/GrowerListing';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp.landing-user-list',
  templateUrl: './cpp-user-list-landing.component.html',
  styleUrls: ['./cpp-user-list-landing.component.scss']
})
export class CppUserListLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  filterArray = [];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  dashboardFilter: DashboardFilter;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();

  @ViewChild('deliveryInstructionTable', { read: MatSort }) deliveryInstructionSort: MatSort;

  public deliveryInstructionList: any;
  public deliveryInstructionDataSource: MatTableDataSource<any>;
  displayedDeliveryInstructionColumns: string[] = ['accountName', 'accountNumber', 'updatedBy', 'dateUpdated'];
  deliveryInstructionFilter = { account: '' };
  accessTypeMode = false;
  userMenuAccessList: any;

  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private cppUserListService: CppUserListService,
    private commonService: CommonService,
    private loaderService: LoaderService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getDeliveryInstructionGridData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();

    this.accessTypeMode = false;
    setTimeout(x => {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (evolveAccessData) {
          this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
          if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_USER_LIST, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
            this.accessTypeMode = true;
          }
        }
      }
    }, 500);
  }

  getDeliveryInstructionGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(
      this.cppUserListService.getcppUserList(this.deliveryInstructionFilter).subscribe(
        (result: any[]) => {
          this.deliveryInstructionList = result.sort((a, b) => new Date(b.updateTimeStamp).getTime() - new Date(a.updateTimeStamp).getTime());
          this.deliveryInstructionDataSource = new MatTableDataSource(this.deliveryInstructionList);
          this.deliveryInstructionDataSource.sort = this.deliveryInstructionSort;

          this.loaderService.setLoaderStatus(false);
        },
        (error) => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  setFilterAndGridColumn() {
    this.filterOptionsData = [
      {
        label: 'Account Number',
        key: 'account',
        controlType: ControlType.Integer,
      },
      {
        label: 'Account Name',
        key: 'accountName',
        controlType: ControlType.Text,
      },
      {
        label: 'Account City',
        key: 'accountCity',
        controlType: ControlType.Text,
      },
      {
        label: 'Account State',
        key: 'accountState',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Updated Date',
        key: 'updatedDate',
        controlType: ControlType.DateRange,
      }
    ];

    this.getDropDownData();
  }

  // Set default filter values
  setDefaultFilter() {
    this.deliveryInstructionFilter = {
      account: '',
    };
  }

  // Search Action
  filterSearchClick(event) {
    this.deliveryInstructionFilter = event;
    this.getDeliveryInstructionGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.deliveryInstructionFilter = event;
    this.getDeliveryInstructionGridData();
  }

  getDropDownData() {
    if (this.headerCompany && this.headerYear) {
      this.subscription.add(this.commonService
        .getFilterDDLData()
        .subscribe(
          (result) => {
            const data = result as dashboradDDL;
            // setting state drop down and remove All states value from list
            this.filterOptionsData.find((x) => x.key == 'accountState').controlData = data.states;
          },
          (error) => LolLoggerService.error(error)
        ));
    }
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Set Height
  setHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.account-filter').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 187;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }, 100);
  }

  addEditDeliveryInstruction() {
    this.cppUserListService.editDeliveryAccountNo = null;
    this.router.navigate(['/cpp/cpp-create-edit-user-list']);
  }

  navigateToEditDeliveryInstructions(element: any) {
    this.cppUserListService.editDeliveryAccountNo = element.accountNumber;
    this.router.navigate([
      '/cpp/cpp-create-edit-user-list'
    ]);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
